import { ERROR_NOT_FOUND, ERROR_UNAUTHORIZED, ERROR_UNSUPPORTED_DEVICE, ERROR_CANNOT_LOAD_DATA } from '../../store/error/actions';
import CannotLoadData from '../CannotLoadData';
import NoResource from '../NoResource';
import UnsupportedDevice from '../UnsupportedDevice';
import { useSelector } from 'react-redux';

const Error = () => {
  const { type } = useSelector((s) => s.error);

  if (type === ERROR_UNSUPPORTED_DEVICE) {
    return <UnsupportedDevice />;
  }

  if (type === ERROR_CANNOT_LOAD_DATA) {
    return <CannotLoadData />;
  }

  if (type === ERROR_UNAUTHORIZED || type === ERROR_NOT_FOUND) {
    return <NoResource />;
  }

  return null;
};

export default Error;
